import ArrowRightIcon from '@/components/icons/arrow-right';
import { cn } from '@/lib/utils';

interface ListItemProps extends React.HTMLAttributes<HTMLDivElement> {
  formName: string;
}

function ListItem({ className, formName, ...props }: ListItemProps) {
  return (
    <div className={cn('active:bg-grey-2 flex h-fit w-full cursor-pointer flex-col items-start bg-white p-0', className)} {...props}>
      <div className="border-grey-2 flex h-fit w-full flex-row items-center gap-2.5 border-b-2 p-5 px-2">
        <div className="text-default-text w-full overflow-hidden text-base font-bold overflow-ellipsis whitespace-nowrap">{formName}</div>
        <ArrowRightIcon size={30} />
      </div>
    </div>
  );
}

export { ListItem };
